<template>
    <div :style="{ height: wrapperHeight + 'px' }" class="list">
		<!-- 是否处理成功弹框 -->
		<confirm-modal v-if="isSuccess" :isEnough="true" :firmTitle="firmTitle_1" :firmLeft="firmLeft_1" :firmRight="firmRight_1"
		    @leftClick="onCloseModalClick" @rightClick="submitSuccess">
		</confirm-modal>

        <!-- 设置截止时间成功 -->
        <confirm-modal v-if="isSetTime" :noWidth="true" :isEnough="true" :firmTitle="firmTitle" :firmLeft="firmLeft" :firmRight="firmRight"
            @leftClick="goBackList" @rightClick="lookOrder">
        </confirm-modal>
        
        <!-- 是否设置截止时间弹框 -->
        <common-modal :showClose="true" v-if="isShowTime"  @close-modal="onCloseModalClick">
            <div class="modal">
                <div class="title">是否设置截止时间</div>
                <div class="time-common set-time" @click="showDatePicker">设置截止时间</div>
                <div class="time-common no-time"  @click="noSetHandle">无需设置</div>
            </div>
        </common-modal>
		
		<!-- 撤单原因弹框 -->
		<common-modal :showClose="true" v-if="isRescind" @close-modal="onCloseModalClick">
			<div class="modal ">
			    <div class="title">请选择撤回原因</div>
			    <ul class="list-wrap che-dan">
					<li>
						<textarea class="textarea" :rows="8" v-model="otherReason" @blur="backHeight" placeholder="请详细描述撤回原因"/>
					</li>
					
					<li class="admin-img">
						<div class="num">上传图片（{{addImages.length }}/6）</div>
						<imageUpload v-model="addImages" :limit="6" class="add-img"/>
					</li>
			    </ul>
			    <div class="modal-submit" @click="submitRescind">提交</div>
			</div>
		</common-modal>
        
        <!-- 是否撤回订单,确认退款，撤单弹框-->
        <confirm-modal v-if="isRevoke" :firmTitle="firmTitle_2" :firmLeft="firmLeft_1" :firmRight="firmRight_1"
            @leftClick="onCloseModalClick" @rightClick="submitRevoke">
        </confirm-modal>
		
		<!-- 搜索栏 -->
		<div class="fixed-wrap">
			<div class="search-wrap">
				<form action="#" onsubmit="return false" class="search-content">
				  <input id="searchInput" ref="input1" type="search" v-model.trim="keyword" @keyup.13='search' placeholder="请输入订单编号/买家旺旺/卖家旺旺查找">
				</form> 
			</div>
			
			<div class="tabs myorder-tab">
				<p class="tab-btn" v-for="(item,index) in tabs" :key='index' :class='tabCur==item.status?"btn-active":""' @click="changeTabs(item)">
					<span>{{item.name}}</span>
					<span v-if="item.status==2 && isShowUnRead" class="unpay-num"></span>
				</p>
			</div>
		</div>
		
		<mt-loadmore v-if="orderList && orderList.length"  :bottom-method="loadBottom" :auto-fill="false" :bottom-all-loaded="allLoaded" ref="loadmore" :bottomPullText='"加载更多"' :bottomLoadingText='"加载中"' :bottomDropText='"释放加载"'>
			<div class="page-con">
				<div class="c_item" v-for="(item,index) in orderList" :key="index" @click="goToDetail(item)">
					<div class="i_part1">
						<div class="c_item_img">
							<img :src="imgUrl+item.server_info.server_icon" alt="">
							<p class="title-c">{{item.server_info.server_name}}</p>
							<p class="status-c">{{item.statusName}}</p>
						</div>
						
						<div class="c_item_info">
							<img src="@/assets/images/order-manage/ic_order_2.png" alt="">
							<span class="order-num">{{item.order_code}}</span>
							<div class="copy" @click.stop="utils.copyText(item.order_code)">复制</div>
							<img v-if='item.server_type==1' src="@/assets/images/order-manage/ic_order_1.png" alt="" class="wang-wang">
							<span v-if='item.server_type==1' class="name">{{item.merchant_wangwang}}</span>
						</div>
						
						<div class="c_item_info mp-b">
							<img src="@/assets/images/order-manage/ic_order_time.png" alt="">
							<span class="order-num">{{item.create_time}}</span>
						</div>
					</div>
					
					
					<div class="i_part2">
						<p class="p_count">佣金：<span class="i_money">¥{{item.commission_price}}</span></p>
						
						<!--1待支付 2待处理 3 处理中 4待确认 5已完成 6 已撤单 7 取消订单 8 已驳回 9已退款 10退款中 11未解决 -->
						<p class="p_btns">
							<!-- 2待处理 -->
							<span class="acDo_btn_2" v-if="item.order_status==2" @click.stop="handle(index)">开始</span> 
							
							<!-- 3 处理中 -->
							<span class="acDo_btn_1" v-if="item.order_status==3" @click.stop="rescind(index)">撤回</span>
							<span class="acDo_btn_2" v-if="item.order_status==3" @click.stop="handleSuccess(index)">成功</span>
							
                            <template v-if='item.order_status==3 || item.order_status==4 || item.order_status==5 || item.order_status==6 || item.order_status==9 || item.order_status==11|| item.order_status==8 || item.order_status==10 || item.order_status==13'>
                                <!-- 3 处理中 4待确认 5已完成 8 已驳回 9(并且是线下订单)  10退款中  已关闭（包括，9已退款，11未解决，6 已撤单）--> 
                                <span class="acDo_btn_3"  v-if="item.order_status==5 || item.order_status==6 || item.order_status==9 || item.order_status==11 || item.order_status==13" @click.stop="follow(index)">进度</span>
                                <span class="acDo_btn_1" v-else-if="item.order_status==3 || item.order_status==4" @click.stop="follow(index)">进度</span>
                                <span class="acDo_btn_2" v-else @click.stop="follow(index)">进度</span>
                            </template>
              <span class="acDo_btn_3" v-if="['5','8','9'].includes(item.order_status)" @click.stop="delOrder(item)">删除</span>
            </p>
					</div>
				</div>
				
			</div>
		</mt-loadmore>
		<div v-else>
			<div class="no-order">
				<img src="../assets/images/no-order.png">
                <p>暂无订单</p>
			</div>
		</div>
    </div>
</template>
<script>
import utils from '@/assets/jslibs/utils'
import {getSalesmanOrder,processingOrder,delOrders} from '@/api/order'
import imageUpload from '@/components/ImageUpload';
import ConfirmModal from '@/components/ConfirmModal'
import CommonHeader from '@/components/CommonHeader'
import CommonModal from '@/components/CommonModal'

export default {
    name : 'myOrder',
    data(){
        return {
			utils,
			wrapperHeight:0,
			allLoaded:false,
			imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
			isSuccess:false,  		//是否处理成功弹框
            isSetTime:false,        //设置截止时间成功弹框
            deadline:"",            //截止时间
            order_uuid:"",         //当前操作订单的id
            isShowTime:false,      //是否设置时间弹框
            isSubmit:false,        //确认完成弹窗
			isRevoke:false,         //是否撤回订单，以及驳回状态下的是否撤单
			isRescind:false,		
			firmTitle_2:"是否撤回该订单",
            firmTitle:"截止时间设置成功",
            firmLeft:"返回列表",
            firmRight:"查看订单",
			
            firmTitle_1:"订单解决了吗？",
            firmLeft_1:"否",
            firmRight_1:"是",
            
            count:"",           //记录用户当前操作订单的下标
			tabCur:1,
			tabs:[{name:"全部",status:1},{"name":"处理中",status:3},{"name":"待处理",status:2},{"name":"未解决",status:5},{"name":"已成功",status:4}],
            orderList:[],
            page_index: 1,
            page_size: 25,
			searchTimer:null,	//搜索截流
			keyword:"",				//搜索关键字
			otherReason:"",        //撤单的其它原因
			addImages:[],          //上传的图片
			isShowUnRead:false
        }
    },
	
	beforeCreate(){
		sessionStorage.removeItem("roleType");
	},
    
    created(){
       this.getSalesmanOrder("1")
    },
	
	mounted(){
	    this.wrapperHeight = document.documentElement.clientHeight;
        document.title = "我的订单";
		window.addEventListener('touchmove', (event)=>{ 
		    if(this.isShowTime || this.isSuccess || this.isSetTime || this.isRevoke){
		        event.preventDefault(); 
		    }
		}) 
	},
    
    methods:{
        async getSalesmanOrder(type){
			this.orderList =[];
			if(this.isMobile==2){//pc端展示所有的
				this.page_size = 999;
			}
            let obj={status:type,keyword_search:this.keyword,page_index:this.page_index,page_size:this.page_size};
            const { data, status } = await getSalesmanOrder(obj);
            if (status !== 200) return 
            this.orderList = data.data;
			if(data.data.length){
			    this.page_index += 1;
			}
			this.orderList.forEach((item,index)=>{
				item.statusName = utils.statusToName(item.order_status);
				if(item.statusName == "已退款" || item.statusName == "未解决"){
					item.statusName = "已关闭"
				}
                if(item.statusName=="已撤单"){
                    item.statusName = "已撤回"
                }
				if(item.order_status == "2"){//如果有待处理订单,则显示未读标记
					this.isShowUnRead = true
				}
			})
        },
		
		loadBottom(){
		    this.$refs.loadmore.onBottomLoaded();
		    this.$refs.loadmore.onTopLoaded();
		    this.loadMore()
		},
		
		async loadMore(){
			let obj={status:this.tabCur,keyword_search:this.keyword,page_index:this.page_index,page_size:this.page_size};
		    const { data, status } = await getSalesmanOrder(obj);
		    if( status !== 200) return
		    if(data.data.length){
		        this.page_index += 1
		        this.orderList = this.orderList.concat(data.data);
				this.orderList.forEach((item,index)=>{
					item.statusName = utils.statusToName(item.order_status);
					if(item.statusName == "已退款" || item.statusName == "已撤单" || item.statusName == "未解决"){
						item.statusName = "已关闭"
					}
					if(item.order_status == "1"){//如果有待处理订单,则显示未读标记
						this.isShowUnRead = true
					}
				})
		    }else{
		        window.toast("没有更多数据","txt");
		    }
		},
        
        // 开始处理
        handle(index){
            this.isShowTime = true;
            this.order_uuid = this.orderList[index].uuid;
        },
		
		// 处理成功
		handleSuccess(index){
			this.isSuccess = true    //和设置时间成功共用弹框
			this.order_uuid = this.orderList[index].uuid;
		},
		
		//跟进记录
		follow(index){
			this.order_uuid = this.orderList[index].uuid;
			this.$router.push({path:'./order-speed',query:{order_uuid:this.order_uuid,follow:"sale"}})
		},
		//删除订单
     delOrder(item){
        //confirm('确实要删除该内容吗?','HHHH')

        this.$createDialog({
          type: 'confirm',
          icon: '',
          title: '确认删除订单？',
          content: '',
          confirmBtn: {
            text: '取消',
            active: true,
            disabled: false,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: '确认',
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
          onConfirm: () => {
            //取消按钮
          },
          onCancel: () => {
            delOrders(item.uuid);
            this.$createToast({
              type: 'correct',
              time: 1000,
              txt: '删除成功'
            }).show()
            this.page_index = 1;
            this.getSalesmanOrder(this.tabCur)
          }
        }).show()
      },
		// 撤回订单
		rescind(index){
			this.isRescind= true;
			this.order_uuid = this.orderList[index].uuid;
		},
		
        // 设置处理的截止时间
        showDatePicker() {
            this.isShowTime = false;
            if (!this.datePicker) {
                this.datePicker = this.$createDatePicker({
                    title: '设置截止时间',
                    min: new Date(2008, 7, 8),
                    max: new Date(2020, 9, 20),
                    value: new Date(),
                    onSelect: this.selectHandle,
                    onCancel: this.cancelHandle
                })
            }
            
            this.datePicker.show()
        },
        
        //确定选择时间，并开始处理
        selectHandle(date, selectedVal, selectedText) {
            this.deadline = selectedVal[0]+"-"+selectedVal[1]+"-"+selectedVal[2];
            this.processingOrder("1");     //处理订单
        },
		
		//无需设置截止时间，直接开始处理
		noSetHandle(){
		    this.isShowTime = false;
			this.firmTitle = "订单开始处理中" 	//直接处理成功提示语不一样
		    this.processingOrder("1");
		},
		
		//确认完成订单
		submitSuccess(){
			this.isSuccess = false
			this.processingOrder("2");          //确认处理成功订单
		},
		
		// 确认撤回订单，退款，驳回下的撤单
		submitRevoke(){
			this.isRevoke = false;
			this.processingOrder("3");
		},
		
		// 确定撤销订单
		submitRescind(){
            if(!this.otherReason){
                window.toast("请输入撤回原因","txt");
                return
            }
            
            if(this.otherReason.length>100){
                window.toast("撤回原因不得超过100字符","txt");
                return
            }
			this.isRescind = false
			this.processingOrder("4");
		},
        
        // 操作订单
        async processingOrder(type){
            let obj={type:type,deadline:this.deadline,reasons_for_cancellation:this.otherReason,img:this.addImages};
            const { data, status } = await processingOrder(this.order_uuid,obj);
            if (status !== 200) return  
			if(type=="1"){
				this.isSetTime = true
			}else if(type=="2"){
				this.page_index = 1;
				this.getSalesmanOrder(this.tabCur)	//确认完成订单之后，刷新订单，从第一页开始查
			}else if(type=="4"){						//撤回订单	
				// this.page_index = 1;
				// this.getSalesmanOrder(this.tabCur+1)
				this.firmTitle = "撤回成功"
				this.isSetTime = true
			}
        },
        
        // 返回列表,并重新获取状态,当前页面下直接关闭弹框
        goBackList(){
            this.isSetTime = false;
			this.page_index = 1;
            this.getSalesmanOrder(this.tabCur)
        },
        
        // 查看订单
        lookOrder(){
			this.isSetTime = false;
            this.$router.push({path:'./orderdetail-sale',query:{order_uuid:this.order_uuid}})
        },
 
        // 取消或者关闭弹框
        onCloseModalClick(){
            this.isShowTime = false;
			this.isSuccess = false;
			this.isRevoke = false;
			this.isRescind = false;
        },
        
		changeTabs(item){
			this.orderList = [];
			this.tabCur = item.status;
			this.page_index = 1;
			this.getSalesmanOrder(this.tabCur)
		},
        
		// 查看订单详情
		goToDetail(item){
			this.$router.push({path:'./orderdetail-sale',query:{order_uuid:item.uuid}})
		},
		
		clearTimer() {
			if (this.searchTimer) {
			  clearTimeout(this.searchTimer);
			}
		},
		
		search(){
			this.$refs.input1.blur();
			this.getSalesmanOrder(1);
		},
		
		backHeight(){
		    setTimeout(() => {
		        const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
		        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
		    }, 100);
		}
    },
	
	watch:{
		keyword(){
			this.clearTimer();
	        this.searchTimer = setTimeout(()=>{
	            this.page_index =1;
	            this.getSalesmanOrder("1")
	        },500)
		}
	},
    
    components : {
       CommonHeader,
       ConfirmModal,
       CommonModal,
	   imageUpload
    }
}
</script>
<style lang='less' scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	.no-order{width:56px;height:82.5px;margin: 0 auto;margin-top:50%;margin-bottom:50%}
	.no-order img{width: 100%;height: 100%}
	.no-order p{text-align: center;font-size:13px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(207,207,207,1);line-height:18.5px;margin-top: 10.5px}
	.list{overflow-y: scroll; width: 100%;height: 100%;padding-bottom: 50px;-webkit-overflow-scrolling: touch;background: #f5f5f5;};
    body{width:100%;height:100%;background:#F5F5F5;font-family:PingFangSC-Regular;font-weight:400;}
    .tabs{width:100%;.h(44);display:flex;background:#fff;z-index: 9}
    .tab-btn{flex:1;.l-h(44);text-align:center; .f-s(14);font-family:PingFangSC-Medium;font-weight:500;position: relative}
    .tab-btn span{display:inline-block;.h(43);.l-h(43);}
	.tab-btn .unpay-num{display: inline-table;position: absolute;width: 7px;height: 7px;border: none;background: rgba(255,134,48,1);border-radius: 50%;top: 26%;right: 10%;}
    .btn-active span{color:#4184F4;border-bottom:1px solid #4184F4;}
    .page-con{padding:0.3rem; background:#f5f5f5;}
    .c_item{padding:0.2rem; padding-bottom:0; background:#fff;margin-bottom:0.3rem;}
	.i_part1{border-bottom:1px solid #f5f5f5;}
	.i_part1 .c_item_img{display:flex;align-items: center;}
	.i_part1 .c_item_img img{height: 21px;width: 21px;margin-right: 9px;}
	.i_part1 .c_item_img .title-c{font-weight: bold;color: rgba(51,51,51,1);font-size: 15px;}
	.i_part1 .c_item_img .status-c{font-weight: bold;color: rgba(65,132,244,1);font-size: 13px;width: 1.6rem; text-align: right;flex: 1;}
	.i_part1 .c_item_info{display: flex;align-items: center;padding-top: 15px;}
	.i_part1 .mp-b{margin-top: 6px;margin-bottom: 8px;padding-top: 0px;}
	.i_part1 .c_item_state{.w(60);line-height:0.6rem; text-align:right; .f-s(13); color:#333;}
	.i_part1 .state_sp{color:rgba(65,132,244,1);}
	.i_part1 .state_pp{.f-s(12);font-family:PingFangSC-Regular;font-weight:400;color:rgba(245,171,21,1);}

	.c_item_info img{width: 15px;height: 15px;}
	.c_item_info .order-num{font-size: 14px;font-family: PingFangSC-Regular,PingFang SC;font-weight: 400;color: rgba(174,174,174,1);margin: 0 5px 0 9px;}
	.c_item_info .copy{font-size: 12px;font-family: PingFangSC-Regular,PingFang SC;font-weight: 400;color: rgba(174,174,174,1);padding: 1px 5px;border-radius: 1px; border: 1px solid rgba(193,193,193,1);}
	.c_item_info .wang-wang{margin: 0 4px 0 32px}
	.c_item_info .name{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;/*width: 120px;*/font-size: 14px;font-family: PingFangSC-Regular,PingFang SC;font-weight: 400;color: rgba(174,174,174,1);}
	
    .i_part2{.h(50);}
    .p_count{float:left;.l-h(50); .f-s(13); color:rgba(51,51,51,1);}
    .p_count .i_money{ .f-s(14);color:rgba(255,134,48,1);}
    .p_btns{float:right;.l-h(50)}
    .p_btns span{display:inline-block; .h(30); .w(65);text-align:center; .l-h(28); color:#999; border:1px solid #999;margin:0 0.2rem;border-radius:2px;font-size: 13px}
    .p_btns .acDo_btn_1{border-color:#4184F4; color:#4184F4;}
    .p_btns .acDo_btn_2{background:#4184F4;border-color:#4184F4;color:#fff;}
    .p_btns .acDo_btn_3{background:#f5f5f5;color:#999;border-color:#f5f5f5;}
    
    /* 追加订单费用 */
    .modal{width: 320px;/* height: 327px; */background: #fff;margin: 0 auto;padding-bottom: 20px;}
    .title{padding: 12px 21px;/* background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat 93% center;background-size: 12px; */font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
   /* .cost{margin-bottom: 10px;font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);}
    .cost-wrap{padding-left: 23px;padding-top: 20px}
    .cost-num{width:278px;height:40px;padding-left: 22px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(151,151,151,1);font-family:PingFangSC-Regular;font-size:13px;font-weight:400;color:rgba(153,153,153,1);}
    .un-boder{border: none;justify-content: space-between;}
    .modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}
    .submit-mt{margin-top: 110px} */
    
    /* 是否设置截止时间弹框 */
    .time-common{.w(277.5);.h(40);.l-h(40);margin:0 auto;border-radius:5px;text-align: center;.f-s(18);font-family:PingFangSC-Regular;font-weight:400;}
    .set-time{background:rgba(65,132,244,1);color:rgba(255,255,255,1);margin: 19px auto 20px auto}
    .no-time{background:rgba(255,255,255,1);border:1px solid rgba(207,207,207,1);color:rgba(153,153,153,1);}
	
	/* 搜索栏 */
	.fixed-wrap{position: -webkit-sticky;position: sticky;top: 0;left: 0;right: 0;width: 100%;}
	.search-wrap{width:100%;height:57.5px;display: flex;align-items: center;justify-content: center;background:rgba(255,255,255,1);border-bottom: 1px solid #E5E5E5;}
	.search-content{width:345px;height:37.5px;background:rgba(245,245,245,1);border-radius:3px;}
	.search-content input{height: 100%;width: 100%;box-sizing: border-box; padding-left: 37px;background:#f5f5f5 url("../assets/images/order-manage/ic_search.png") no-repeat 9px center;background-size: 18px;}

	/* 撤单理由弹框 */
	.list-wrap{padding: 18px 21px 6px 21px;}
	.list-wrap li{margin-bottom: 10px}
	.select-mark{display: inline-block;width:17px;height:17px;border-radius: 50%;margin-right: 7px;vertical-align: top;margin-top: 4px}
	.modal-text{display: inline-block;width: 243px;font-size:15px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);vertical-align: top;}
	.modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:5px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}
	.textarea{width: 278px;height: 100px;padding: 10px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(207,207,207,1);resize: none;outline: none;font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(153,153,153,1);}
	.done{background: url(../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
	.num{font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);margin-bottom: 12px}
	.dankal-image-upload /deep/ .add-box{padding-left: 0 !important}
	.dankal-image-upload /deep/ .add-box /deep/ .add{width: 80px;height: 80px}
	.dankal-image-upload /deep/ p /deep/ .upload_img{width: 80px;height: 80px}
    .p_btns .un-click{background: #999;border-color:#999}
</style>    